module.exports = __webpack_public_path__ + "img/jixianzuo.prt.65cbdf5f.jpg";